export default "__VITE_ASSET__CnOsJgSS__"